<!-- la barra se instancia en dos lugares según el ancho: junto a los botones desde 2xl,
     y en su propia fila bajo el título cuando no cabe (laptops) -->
<ng-template #searchBar>
  <mat-form-field subscriptSizing="dynamic" floatLabel="never" class="dg-item-search w-full min-w-0">
    <button matPrefix mat-icon-button type="button" [matTooltip]="'DOCUMENT_GENERATE.ITEMS_TABLE.SEARCH_ITEM_TOOLTIP' | t" [disabled]="!canAdd"
      (mousedown)="$event.preventDefault()" (click)="itemTrigger.closePanel(); itemInput.blur(); openSearch.emit()">
      <mat-icon>search</mat-icon>
    </button>
    <input type="text" #itemInput #itemTrigger="matAutocompleteTrigger" matInput
      [placeholder]="'DOCUMENT_GENERATE.ITEMS_TABLE.SEARCH_PLACEHOLDER' | t" [attr.aria-label]="'DOCUMENT_GENERATE.ITEMS_TABLE.ITEM_LABEL' | t" [(ngModel)]="searchValue"
      [matAutocomplete]="autoItem" (ngModelChange)="onSearchInput($event)" (keyup.enter)="submitFromEnter()">
    <mat-autocomplete #autoItem="matAutocomplete" class="dg-item-autocomplete" [displayWith]="displayNothing"
      (optionSelected)="onResultPicked($event.option.value)">
      @if (searchLoading) {
      <!-- el listado resuelve precios y tarda: el skeleton avisa que la búsqueda va en camino -->
      <mat-option disabled class="dg-search-status">
        <div class="flex w-full flex-col gap-2 py-1">
          <div class="h-3 w-3/4 animate-pulse rounded bg-gray-200 dark:bg-gray-700"></div>
          <div class="h-3 w-1/2 animate-pulse rounded bg-gray-200 dark:bg-gray-700"></div>
          <div class="h-3 w-2/3 animate-pulse rounded bg-gray-200 dark:bg-gray-700"></div>
        </div>
      </mat-option>
      } @else if (canAdd && searchValue.trim() && !searchResults.length) {
      <mat-option disabled class="dg-search-status">
        <span class="text-secondary">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.NO_RESULTS_FOR' | t: { term: searchValue.trim() } }}</span>
      </mat-option>
      } @else {
      @for (m of searchResults; track m._id) {
      <mat-option [value]="m" class="text-content">
        <span class="block w-full whitespace-normal break-words">{{ resultCode(m) }} - {{ m.name }}</span>
      </mat-option>
      }
      }
    </mat-autocomplete>
  </mat-form-field>
</ng-template>

<div class="flex h-full w-full flex-col">
  <div class="flex flex-col gap-1">
    <div class="flex flex-col gap-2 sm:flex-row sm:items-start" [class.sm:justify-between]="!embedded"
      [class.sm:justify-end]="embedded">
      @if (!embedded) {
      <h3 class="section-title">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.TITLE' | t }}</h3>
      }
      <div class="flex w-full flex-wrap items-center gap-2" [class.sm:w-auto]="!embedded">
        @if (!embedded && showSuggestions) {
        <button mat-button color="primary" type="button" class="max-sm:portrait:flex-1" (click)="openSuggestions.emit()">
          <mat-icon fontSet="material-icons-outlined">lightbulb</mat-icon>
          {{ 'DOCUMENT_GENERATE.ACTIONS.SUGGESTIONS' | t }}
        </button>
        }
        @if (!embedded && !compact) {
        <button mat-button color="primary" type="button" (click)="expand.emit()">
          <mat-icon>view_list</mat-icon>
          {{ 'DOCUMENT_GENERATE.ITEMS_TABLE.EXPAND' | t }}
        </button>
        }
        <div [ngClass]="embedded ? 'min-w-0 flex-1' : 'hidden 2xl:block 2xl:w-[34rem] 2xl:shrink-0'">
          <ng-container *ngTemplateOutlet="searchBar"></ng-container>
        </div>
        <button mat-flat-button color="primary" type="button" class="max-sm:portrait:flex-1" (click)="submit()" [disabled]="!canAdd">
          <mat-icon>add</mat-icon>
          {{ 'GENERAL.ADD' | t }}
        </button>
      </div>
    </div>
    @if (!embedded) {
    <div class="section-line"></div>
    <div class="mt-2 w-full 2xl:hidden">
      <ng-container *ngTemplateOutlet="searchBar"></ng-container>
    </div>
    }
  </div>

  <div class="mt-3 flex min-h-0 flex-1 flex-col overflow-hidden rounded-2xl border"
    [class.dg-items-shell]="!embedded">
    @if (compact) {
    <!-- tarjetas -->
    <div class="min-h-0 flex-1 overflow-auto p-3">
      @if (embedded && items.length) {
      <div class="mb-3 flex items-center gap-2">
        <mat-checkbox [checked]="allSelected()" [indeterminate]="someSelected()"
          (change)="toggleAll($event.checked)"></mat-checkbox>
        <span class="text-secondary text-sm">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.SELECT_ALL' | t }}</span>
      </div>
      }
      <div class="flex flex-col gap-3">
        @for (item of items; track item.lineId) {
        <div class="flex flex-col rounded-xl border bg-card p-3"
          [class.border-primary]="embedded && isSelected(item)">
          <div class="flex items-start gap-2">
            @if (embedded) {
            <mat-checkbox class="-ml-2" [checked]="isSelected(item)" (change)="toggle(item)"></mat-checkbox>
            }
            <div class="flex min-w-0 flex-1 flex-col">
              <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.LINE_NUMBER' | t }} {{ displayNumber(item) }}</span>
              <span class="inline-flex items-center gap-1.5 font-semibold" [class.italic]="item.isBonus">
                @if (item.isBonus) {
                <mat-icon class="icon-size-4 text-green-600 dark:text-green-400">subdirectory_arrow_right</mat-icon>
                }
                {{ item.code }}
                @if (item.withoutStock) {
                <span class="rounded-full bg-red-100 px-1.5 py-0.5 text-[10px] font-semibold text-red-700 dark:bg-red-900/40 dark:text-red-300"
                  [matTooltip]="'DOCUMENT_GENERATE.ITEMS_TABLE.OVER_STOCK_TOOLTIP' | t">{{ 'DOCUMENT_GENERATE.BADGES.NO_STOCK' | t }}</span>
                }
                @if (!item.isBonus) {
                <app-bom-cell [material]="item.material" />
                <app-bonus-cell [bonus]="item.bonusInfo" />
                }
                @if (item.isBonus) {
                <span class="rounded-full bg-green-100 px-1.5 py-0.5 text-[10px] font-semibold text-green-700 dark:bg-green-900 dark:text-green-300">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.FREE_BADGE' | t }}</span>
                }
              </span>
              <span class="text-secondary text-sm uppercase">{{ item.name }}</span>
              @if (warehouseLabel(item)) {
              <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.WAREHOUSE_PREFIX' | t }} {{ warehouseLabel(item) }}</span>
              }
            </div>
            <button mat-icon-button type="button" class="-mr-2 -mt-1 shrink-0" [matMenuTriggerFor]="rowMenu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #rowMenu="matMenu">
              <button mat-menu-item type="button" (click)="openDetail.emit(item)">
                <mat-icon>description</mat-icon>
                <span>{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.DETAIL_MENU' | t }} @if (detailCount(item)) { ({{ detailCount(item) }}) }</span>
              </button>
              @if (hasAlternalUnits(item)) {
              <button mat-menu-item type="button" (click)="openCalculator.emit(item)">
                <mat-icon>calculate</mat-icon>
                <span>{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.CALCULATOR_TOOLTIP' | t }}</span>
              </button>
              }
              @if (allowMultipleWarehouses && !item.isBonus) {
              <button mat-menu-item type="button" (click)="openWarehouses.emit(item)">
                <mat-icon>warehouse</mat-icon>
                <span>{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.DISTRIBUTE_WAREHOUSES' | t }} @if (warehouseCount(item) > 1) { ({{ warehouseCount(item) }}) }</span>
              </button>
              }
              <button mat-menu-item type="button" [disabled]="embedded && selected.size > 1"
                (click)="removeRow(item)">
                <mat-icon color="warn">delete</mat-icon>
                <span>{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.REMOVE_TOOLTIP' | t }}</span>
              </button>
            </mat-menu>
          </div>

          <div class="mt-3 grid grid-cols-2 gap-3 border-t pt-3">
            <div class="flex flex-col gap-1">
              <span class="text-secondary text-xs font-medium uppercase">{{ 'DOCUMENT_GENERATE.FIELDS.QUANTITY' | t }}</span>
              <input type="text" inputmode="decimal" [ngModel]="item.quantityText"
                (ngModelChange)="onQuantityInput(item, $event)" (keydown)="onQuantityKeydown($event)"
                [disabled]="!item.isCommercialUom || item.isBonus" [class.opacity-50]="!item.isCommercialUom || item.isBonus"
                [class.cursor-not-allowed]="!item.isCommercialUom || item.isBonus"
                class="dg-qty-input w-full rounded-md border px-2 py-1.5 text-center dark:bg-transparent">
              @if (item.bonusIncludedQty) {
              <span class="self-start rounded-full bg-green-100 px-1.5 py-0.5 text-[10px] font-semibold text-green-700 dark:bg-green-900 dark:text-green-300"
                [matTooltip]="'DOCUMENT_GENERATE.ITEMS_TABLE.BONUS_TOOLTIP' | t">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.FREE_UNITS' | t: { count: item.bonusIncludedQty } }}</span>
              }
            </div>
            <div class="flex flex-col gap-1">
              <span class="text-secondary text-xs font-medium uppercase">{{ 'DOCUMENT_GENERATE.PLACEHOLDERS.UNIT' | t }}</span>
              <div class="flex items-center gap-1">
                <span class="min-w-0 flex-1 truncate rounded-md border px-2 py-1.5 text-center text-xs font-medium"
                  [matTooltip]="item.unitLabel">{{ item.unitLabel }}</span>
                <button mat-icon-button color="primary" type="button" class="shrink-0"
                  [matTooltip]="'DOCUMENT_GENERATE.ITEMS_TABLE.CHANGE_UNIT_TOOLTIP' | t" (click)="changeUnit.emit(item)">
                  <mat-icon class="icon-size-5">swap_horiz</mat-icon>
                </button>
              </div>
              @if (!item.isCommercialUom) {
              <span class="self-start rounded-full bg-gray-200 px-1.5 py-0.5 text-[10px] font-semibold text-gray-600 dark:bg-gray-700 dark:text-gray-300"
                [matTooltip]="'DOCUMENT_GENERATE.ITEMS_TABLE.NOT_SELLABLE_TOOLTIP' | t">{{ 'DOCUMENT_GENERATE.BADGES.NOT_SELLABLE' | t }}</span>
              }
              @if (altUnits(item); as alt) {
              <span class="text-secondary min-w-0 max-w-full truncate self-start text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.BASE_UOM_LABEL' | t: { value: (alt.umbQty | dgNumber: 'stock') + ' ' + alt.umbCode } }}</span>
              @if (alt.umsQty != null) {
              <span class="text-secondary min-w-0 max-w-full truncate self-start text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.SECONDARY_UOM_LABEL' | t: { value: (alt.umsQty | dgNumber: 'stock') + ' ' + alt.umsCode } }}</span>
              }
              @if (alt.umpQty != null) {
              <span class="text-secondary min-w-0 max-w-full truncate self-start text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.PACKAGING_UOM_LABEL' | t: { value: (alt.umpQty | dgNumber: 'stock') + ' ' + alt.umpCode } }}</span>
              }
              }
            </div>
          </div>

          <div class="mt-3 grid grid-cols-2 gap-x-4 gap-y-2 border-t pt-3 text-sm">
            <div class="flex items-center justify-between gap-2">
              <span class="text-secondary">{{ 'DOCUMENT_GENERATE.FIELDS.PRICE' | t }}</span>
              @if (editablePrice && !item.isBonus) {
              <input type="text" inputmode="decimal" [ngModel]="item.price"
                (ngModelChange)="onPriceInput(item, $event)" (keydown)="onQuantityKeydown($event)"
                class="dg-qty-input w-20 rounded-md border px-2 py-1 text-right dark:bg-transparent">
              } @else {
              <span class="font-semibold">{{ item.price | dgNumber }}</span>
              }
            </div>
            <div class="flex items-center justify-between gap-2">
              <span class="text-secondary">{{ 'DOCUMENT_GENERATE.TOTALS.SUBTOTAL' | t }}</span>
              <span>{{ rowSubtotal(item) | dgNumber }}</span>
            </div>
            <div class="flex items-center justify-between gap-2">
              <span class="text-secondary">Desc.</span>
              <span>{{ item.discount | dgNumber }}</span>
            </div>
            <div class="flex items-center justify-between gap-2">
              <span class="text-secondary truncate">ISV</span>
              <span>{{ item.isv | dgNumber }}</span>
            </div>
            <div class="col-span-2 flex items-center justify-between gap-2 border-t pt-2">
              <span class="text-secondary font-medium">TOTAL</span>
              <span class="text-primary text-base font-bold">{{ rowTotal(item) | dgNumber }}</span>
            </div>
          </div>
        </div>
        } @empty {
        <div class="flex h-[180px] flex-col items-center justify-center gap-2 px-4 text-center">
          <span class="text-secondary text-base font-medium">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.EMPTY_TITLE' | t }}</span>
          <span class="text-secondary text-sm">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.EMPTY_HINT' | t }}</span>
        </div>
        }
      </div>
    </div>
    } @else {
    <!-- tabla -->
    <div class="min-h-0 flex-1 overflow-auto">
      <table class="w-full min-w-[920px] border-collapse text-sm">
        <thead class="sticky top-0 z-10 bg-gray-50 dark:bg-gray-800">
          <tr class="text-secondary text-left">
            @if (embedded) {
            <th class="px-4 py-3">
              <mat-checkbox [checked]="allSelected()" [indeterminate]="someSelected()"
                (change)="toggleAll($event.checked)"></mat-checkbox>
            </th>
            }
            <th class="w-px whitespace-nowrap px-2 py-3 text-center font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.LINE_NUMBER' | t }}</th>
            <th class="px-4 py-3 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.PRODUCT' | t }}</th>
            <th class="px-4 py-3 text-center font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.QUANTITY' | t }}</th>
            <th class="px-4 py-3 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.SALE_UOM' | t }}</th>
            <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.PRICE' | t }}</th>
            <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.SUBTOTAL' | t }}</th>
            <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.DISCOUNT' | t }}</th>
            <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.TAX' | t }}</th>
            <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.TOTAL' | t }}</th>
            <th class="px-4 py-3"></th>
          </tr>
        </thead>
        <tbody>
          @for (item of items; track item.lineId) {
          <tr class="border-t" [class.bg-primary-50]="embedded && isSelected(item)"
            [class.dark:bg-primary-900]="embedded && isSelected(item)"
            [ngClass]="{ 'bg-green-50 dark:bg-green-900/20': item.isBonus }">
            @if (embedded) {
            <td class="px-4 py-3">
              <mat-checkbox [checked]="isSelected(item)" (change)="toggle(item)"></mat-checkbox>
            </td>
            }
            <td class="w-px whitespace-nowrap px-2 py-3 text-center"
              [class.text-secondary]="item.isBonus" [class.text-xs]="item.isBonus">{{ displayNumber(item) }}</td>
            <td class="px-4 py-3" [class.pl-8]="item.isBonus">
              <div class="flex flex-col" [class.border-l-2]="item.isBonus" [class.border-green-300]="item.isBonus"
                [class.pl-3]="item.isBonus">
                <span class="inline-flex items-center gap-1.5 font-semibold" [class.italic]="item.isBonus"
                  [class.font-medium]="item.isBonus">
                  @if (item.isBonus) {
                  <mat-icon class="icon-size-4 text-green-600 dark:text-green-400">subdirectory_arrow_right</mat-icon>
                  }
                  {{ item.code }}
                  @if (item.withoutStock) {
                  <span class="rounded-full bg-red-100 px-1.5 py-0.5 text-[10px] font-semibold text-red-700 dark:bg-red-900/40 dark:text-red-300"
                    [matTooltip]="'DOCUMENT_GENERATE.ITEMS_TABLE.OVER_STOCK_TOOLTIP' | t">{{ 'DOCUMENT_GENERATE.BADGES.NO_STOCK' | t }}</span>
                  }
                  @if (!item.isBonus) {
                  <app-bom-cell [material]="item.material" />
                  <app-bonus-cell [bonus]="item.bonusInfo" />
                  }
                  @if (item.isBonus) {
                  <span class="rounded-full bg-green-100 px-1.5 py-0.5 text-[10px] font-semibold text-green-700 dark:bg-green-900 dark:text-green-300">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.FREE_BADGE' | t }}</span>
                  }
                </span>
                <span class="text-secondary uppercase" [class.italic]="item.isBonus">{{ item.name }}</span>
                @if (warehouseLabel(item)) {
                <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.WAREHOUSE_PREFIX' | t }} {{ warehouseLabel(item) }}</span>
                }
              </div>
            </td>
            <td class="px-4 py-3 text-center">
              <div class="flex flex-col items-center gap-1">
                <input type="text" inputmode="decimal" [ngModel]="item.quantityText"
                  (ngModelChange)="onQuantityInput(item, $event)" (keydown)="onQuantityKeydown($event)"
                  [disabled]="!item.isCommercialUom || item.isBonus" [class.opacity-50]="!item.isCommercialUom || item.isBonus"
                  [class.cursor-not-allowed]="!item.isCommercialUom || item.isBonus"
                  class="dg-qty-input w-16 rounded-md border px-2 py-1 text-center dark:bg-transparent">
                @if (item.bonusIncludedQty) {
                <span class="rounded-full bg-green-100 px-1.5 py-0.5 text-[10px] font-semibold text-green-700 dark:bg-green-900 dark:text-green-300"
                  [matTooltip]="'DOCUMENT_GENERATE.ITEMS_TABLE.BONUS_TOOLTIP' | t">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.FREE_UNITS' | t: { count: item.bonusIncludedQty } }}</span>
                }
              </div>
            </td>
            <td class="px-4 py-3 text-left">
              <div class="flex items-center justify-start gap-1">
                <div class="flex flex-col items-start gap-1">
                  <span class="inline-block max-w-[90px] truncate rounded-md border px-2 py-1 align-middle text-xs font-medium"
                    [matTooltip]="item.unitLabel">{{ item.unitLabel }}</span>
                  @if (!item.isCommercialUom) {
                  <span class="rounded-full bg-gray-200 px-1.5 py-0.5 text-[10px] font-semibold text-gray-600 dark:bg-gray-700 dark:text-gray-300"
                    [matTooltip]="'DOCUMENT_GENERATE.ITEMS_TABLE.NOT_SELLABLE_TOOLTIP' | t">{{ 'DOCUMENT_GENERATE.BADGES.NOT_SELLABLE' | t }}</span>
                  }
                  @if (altUnits(item); as alt) {
                  <span class="text-secondary whitespace-nowrap text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.BASE_UOM_LABEL' | t: { value: (alt.umbQty | dgNumber: 'stock') + ' ' + alt.umbCode } }}</span>
                  @if (alt.umsQty != null) {
                  <span class="text-secondary whitespace-nowrap text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.SECONDARY_UOM_LABEL' | t: { value: (alt.umsQty | dgNumber: 'stock') + ' ' + alt.umsCode } }}</span>
                  }
                  @if (alt.umpQty != null) {
                  <span class="text-secondary whitespace-nowrap text-xs">{{ 'DOCUMENT_GENERATE.COLUMNS.PACKAGING_UOM_LABEL' | t: { value: (alt.umpQty | dgNumber: 'stock') + ' ' + alt.umpCode } }}</span>
                  }
                  }
                </div>
                @if (!item.isBonus) {
                <button mat-icon-button color="primary" type="button"
                  [matTooltip]="'DOCUMENT_GENERATE.ITEMS_TABLE.CHANGE_UNIT_TOOLTIP' | t" (click)="changeUnit.emit(item)">
                  <mat-icon class="icon-size-4">swap_horiz</mat-icon>
                </button>
                }
              </div>
            </td>
            <td class="px-4 py-3 text-right font-semibold">
              @if (editablePrice && !item.isBonus) {
              <input type="text" inputmode="decimal" [ngModel]="item.price" (ngModelChange)="onPriceInput(item, $event)"
                (keydown)="onQuantityKeydown($event)"
                class="dg-qty-input w-20 rounded-md border px-2 py-1 text-right dark:bg-transparent">
              } @else {
              {{ item.price | dgNumber }}
              }
            </td>
            <td class="px-4 py-3 text-right">{{ rowSubtotal(item) | dgNumber }}</td>
            <td class="px-4 py-3 text-right">{{ item.discount | dgNumber }}</td>
            <td class="px-4 py-3 text-right">{{ item.isv | dgNumber }}</td>
            <td class="px-4 py-3 text-right font-semibold">{{ rowTotal(item) | dgNumber }}</td>
            <td class="px-4 py-3">
              <div class="flex items-center justify-center gap-1">
                <button mat-icon-button color="primary" type="button"
                  [matTooltip]="'DOCUMENT_GENERATE.ITEMS_TABLE.MORE_ACTIONS' | t"
                  [matBadge]="rowActionsBadge(item)" matBadgeColor="accent" matBadgeSize="small"
                  [matMenuTriggerFor]="rowActionsMenu">
                  <mat-icon class="icon-size-5">more_vert</mat-icon>
                </button>
                <mat-menu #rowActionsMenu="matMenu">
                  <button mat-menu-item type="button" (click)="openDetail.emit(item)">
                    <mat-icon>description</mat-icon>
                    <span>{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.DETAIL_MENU' | t }} @if (detailCount(item)) { ({{ detailCount(item) }}) }</span>
                  </button>
                  @if (hasAlternalUnits(item) && !item.isBonus) {
                  <button mat-menu-item type="button" (click)="openCalculator.emit(item)">
                    <mat-icon>calculate</mat-icon>
                    <span>{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.CALCULATOR_TOOLTIP' | t }}</span>
                  </button>
                  }
                  @if (allowMultipleWarehouses && !item.isBonus) {
                  <button mat-menu-item type="button" (click)="openWarehouses.emit(item)">
                    <mat-icon>warehouse</mat-icon>
                    <span>{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.DISTRIBUTE_WAREHOUSES' | t }} @if (warehouseCount(item) > 1) { ({{ warehouseCount(item) }}) }</span>
                  </button>
                  }
                </mat-menu>
                <button mat-icon-button color="warn" type="button"
                  [matTooltip]="(item.isBonus ? 'DOCUMENT_GENERATE.ITEMS_TABLE.REMOVE_BONUS_TOOLTIP' : 'DOCUMENT_GENERATE.ITEMS_TABLE.REMOVE_TOOLTIP') | t"
                  [disabled]="embedded && selected.size > 1" (click)="removeRow(item)">
                  <mat-icon class="icon-size-5">delete</mat-icon>
                </button>
              </div>
            </td>
          </tr>
          } @empty {
          <tr>
            <td [attr.colspan]="embedded ? 11 : 10">
              <div class="flex h-[180px] flex-col items-center justify-center gap-2 px-4 text-center sm:h-[280px]">
                <span class="text-secondary text-lg font-medium">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.EMPTY_TITLE' | t }}</span>
                <span class="text-secondary text-base">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.EMPTY_HINT' | t }}</span>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    }
  </div>
</div>
